import useFlag from "~/hooks/useFlag";
import { LP_CTA_COPY_VARIANT } from "~/constants/flags";
import { LP_CTA_COPY_BY_VARIANT } from "~/constants/lpCtaCopy";

export const getLpCtaText = (fallbackText: string, variant: unknown): string => {
    if (typeof variant !== "string") {
        return fallbackText;
    }

    return (
        LP_CTA_COPY_BY_VARIANT[variant as keyof typeof LP_CTA_COPY_BY_VARIANT] ??
        fallbackText
    );
};

export const useLpCtaText = (fallbackText: string): string => {
    const variant = useFlag(LP_CTA_COPY_VARIANT);

    return getLpCtaText(fallbackText, variant);
};

export default useLpCtaText;